"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Check = _interopRequireDefault(require("../Check"));

var _Tooltip = _interopRequireWildcard(require("../Tooltip"));

var _table = require("./table");

var preventBubble = function preventBubble(e) {
  return e.stopPropagation();
};

var Row =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Row, _PureComponent);

  function Row() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Row);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Row)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (e) {
      var method = e.target.checked ? _this.props.select : _this.props.deselect;

      switch (true) {
        case e.nativeEvent.shiftKey:
          _this.props.massOperation(_this.props.row);

          break;

        default:
          method && method(_this.props.row);
          break;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function () {
      _this.props.onClick(_this.props.row, _this.props.index);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderCell", function (column, key) {
      var fixed = column.fixed,
          align = column.align,
          render = column.render,
          component = column.component;
      var hasTooltip = column.hasOwnProperty('tooltip');
      var tooltip = column.tooltip;
      var props = {
        key: column.key || key,
        className: (0, _classnames.default)('table-cell', {
          'table-cell--fixed': fixed,
          'table-cell--alignRight': align === 'right',
          'table-cell--alignCenter': align === 'center'
        }),
        style: (0, _table.columnStyle)(column)
      };

      var content = _this.renderCellContent(render, component);

      if (!hasTooltip) {
        return _react.default.createElement("div", props, _react.default.createElement(_Tooltip.OverflowTextTooltip, {
          className: "table-cell-content"
        }, content));
      }

      if (tooltip instanceof Function) {
        return _react.default.createElement("div", props, _react.default.createElement(_Tooltip.default, {
          tooltip: tooltip(_this.props.row),
          className: "table-cell-content"
        }, content));
      }

      return _react.default.createElement("div", props, _react.default.createElement("div", {
        className: "table-cell-content"
      }, content));
    });
    return _this;
  }

  (0, _createClass2.default)(Row, [{
    key: "renderCellContent",
    value: function renderCellContent(render, CellComponent) {
      var row = this.props.row;

      if (CellComponent) {
        return _react.default.createElement(CellComponent, this.props);
      }

      if (render && render.prototype instanceof _react.Component) {
        return _react.default.createElement(render, this.props);
      }

      if (render instanceof Function) {
        return render(row, this.props);
      }

      if (render) {
        return row[render];
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          hasSelection = _this$props.hasSelection,
          onClick = _this$props.onClick,
          columns = _this$props.columns,
          active = _this$props.active,
          rowClassName = _this$props.rowClassName,
          checkboxDisabled = _this$props.checkboxDisabled;
      var className = (0, _classnames.default)('table-row', rowClassName, {
        'table-row--selected': checked,
        'table-row--active': active,
        'table-row--clickable': onClick
      });
      return _react.default.createElement("div", {
        onClick: onClick ? this.onClick : null,
        className: className
      }, hasSelection && _react.default.createElement(_Check.default, {
        className: "table-cell table-cell--fixed",
        key: "select",
        greyscale: true,
        checked: checked,
        disabled: checkboxDisabled,
        onClick: preventBubble,
        onChange: this.onChange
      }), columns.map(this.renderCell));
    }
  }]);
  return Row;
}(_react.PureComponent);

exports.default = Row;
Row.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes.default.bool,
  checkboxDisabled: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    align: _propTypes.default.oneOf(['right', 'center']),
    component: _propTypes.default.elementType,
    fixed: _propTypes.default.bool,
    render: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_react.Component), _propTypes.default.func]),
    tooltip: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool])
  })),
  deselect: _propTypes.default.func,
  hasSelection: _propTypes.default.bool,
  index: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  massOperation: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func,
  row: _propTypes.default.object,
  rowClassName: _propTypes.default.string,
  select: _propTypes.default.func
} : {};